import React, { useCallback, useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import GoogleMapComp from "../../passenger/booking/GoogleMapComp";
import "../../passenger/passenger.css";
import { Avatar } from "primereact/avatar";
import { Rating } from "primereact/rating";
import { Timeline } from "primereact/timeline";
import moment from "moment";
import { Tag } from "primereact/tag";
import { baseURL } from "../../../Config";
import { handleEncryptData } from "../../../services/EncryptionService";
import { handleDecryptData } from "../../../services/DecryptionService";
import { getSocket, SOCKET_ENDPOINTS } from "../../../services/Socket";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import defaultImg from "../../../assets/dummy-img.png";
import { handlePostRequest } from "../../../services/PostTemplate";
import { toast } from "react-toastify";
const ConfirmRides = ({ rowData }) => {
    const [visible, setVisible] = useState(false);
    const [statusChanes, setStatusChanges] = useState("");
    const userId = useSelector((state) => state.authenticationSlice?.userId);
    const selectedUserType = useSelector((state) => state.authenticationSlice?.selectedUserType);

    const history = useHistory();
    const dispatch = useDispatch();
    const socket = getSocket();
    const [directions, setDirections] = useState(null);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [startPosition, setStartPosition] = useState(null); // Initially null
    const [endPosition, setEndPosition] = useState(null); // Initially null
    const [data, setData] = useState();
    const [scheduleId, setScheduleId] = useState("");
    const [filteredMatchedList, setFilteredMatchedList] = useState([]);
    const [matchedList, setMatchedList] = useState([]);
    const [flotingBtn, setFlotingBtn] = useState();

    useEffect(() => {
        if (data?.data && Array.isArray(data?.data?.accepted)) {
            const filteredList = data?.data?.accepted.length > 0 && data?.data?.rejected.length === 0;

            if (filteredList) {
                setFilteredMatchedList(data?.matchedPassengers);
                setStatusChanges(data?.data?.status === "started");
            }
        }
    }, [data]);
    const toggleDialog = () => {
        setVisible((prevVisible) => !prevVisible);
    };

    const handleMapLoaded = useCallback(() => {
        setMapLoaded(true);
        if (startPosition) fetchDirections();
    });
    const fetchDirections = () => {
        if (!startPosition) return;
        const directionsService = new window.google.maps.DirectionsService();
        directionsService.route(
            {
                origin: startPosition,
                destination: endPosition,
                travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    setDirections(result);
                } else {
                    console.error("Error fetching directions:", status);
                }
            }
        );
    };

    // Update positions dynamically when `data` changes
    useEffect(() => {
        if (data?.data) {
            const startPoint = data.data.startPoint;
            const endPoint = data.data.endPoint;

            if (startPoint) {
                setStartPosition({
                    lat: startPoint.latitude,
                    lng: startPoint.longitude,
                });
            }

            if (endPoint) {
                setEndPosition({
                    lat: endPoint.latitude,
                    lng: endPoint.longitude,
                });
            }
        }
    }, [data]);

    const handleMatchedList = async () => {
        try {
            let apiEndpoint = "";
            let payload = "";

            if (selectedUserType == "1") {
                // const apiEndpoint = `api/route/getrequests?routeId=${rowData?._id}`;

                apiEndpoint = "api/route/getrequests";
                payload = {
                    ownerId: userId,
                    routeId: rowData?._id,
                    // page: 1,
                };
            } else {
                apiEndpoint = "api/scheduleride/getmatcheddriver";
                payload = {
                    userId: userId,
                    isScheduled: rowData?.isScheduled,
                    scheduleId: rowData?._id,
                };
            }

            if (apiEndpoint) {
                const response = await dispatch(handlePostRequest(apiEndpoint, payload, true, true));
                setData(response.data);
                console.log(response.data);
                setFlotingBtn(response?.data?.data?.status === "started");
                setScheduleId(response?.data?.data?._id || response?.data?.data?.schedule?._id);
                setMatchedList(response?.data?.data?.nearestDriver || response?.data?.matchedPassengers);
            }
        } catch (error) {
            // console.error("Error fetching user vehicle list:", error);
        }
    };
    useEffect(() => {
        handleMatchedList();
    }, []);
    const handleRejectRequest = (matchedId) => {
        if (!matchedId) {
            console.error("Route ID or User ID is missing!");
            return;
        }

        const encryptedData = {
            routeId: scheduleId,
            scheduleId: matchedId,
        };

        const encryptData = handleEncryptData(encryptedData);
        // Emit the socket event
        socket.emit("rejectRequestByDriver", JSON.stringify(encryptData), (response) => {
            const decryptedResponse = handleDecryptData(response?.cipher); // Ensure you have a decrypt utility
            console.log(decryptedResponse, "decryptedResponse");
            if (decryptedResponse?.status === true) {
                console.log("Route cancelled successfully:", decryptedResponse.msg);
                history.push("/schedules");
            } else {
                console.error("Failed to cancel route:", decryptedResponse?.msg);
            }
        });
    };
    
     useEffect(() => {
            if (socket) {
                socket.on(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES, (response) => {
                    console.log("Refresh driver routes:", response);
                    toast.info("Driver routes refreshed");
                    handleMatchedList();
                });
                socket.on(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER, (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("redirectPassengerToActiveRideListner", (response) => {
                    console.log("Redirect passenger to active ride:", response);
                    toast.info("Redirecting to active ride");
                    history.push("/passenger-ride");
                });
                socket.on("refreshPassengerScheduleListner", (response) => {
                    console.log("Refresh passenger schedule:", response);
                    toast.info("Passenger schedule refreshed");
                    handleMatchedList();
                });
                socket.on("passengerRideCancellationListner", (response) => {
                    console.log("Passenger ride cancellation:", response);
                    toast.info("Passenger ride cancelled");
                    handleMatchedList();
                });
                socket.on("driverCompleteRideListner", (response) => {
                    console.log("Driver complete ride:", response);
                    toast.info("Driver completed the ride");
                    handleMatchedList();
                });
            }
    
            return () => {
                if (socket) {
                    socket.off(SOCKET_ENDPOINTS.REFRESH_DRIVER_ROUTES);
                    socket.off(SOCKET_ENDPOINTS.PASSENGER_RIDE_CANCELLATION_LISTENER);
                    socket.off("redirectPassengerToActiveRideListner");
                    socket.off("refreshPassengerScheduleListner");
                    socket.off("passengerRideCancellationListner");
                    socket.off("driverCompleteRideListner");
                }
            };
        }, [socket, handleMatchedList]);

    if (filteredMatchedList?.length === 0) {
        return <h4>No Request come</h4>;
    }

    return (
        <div className="ride-status-container" style={{ position: "relative", padding: "3rem" }}>
            <Button icon="pi pi-external-link" onClick={toggleDialog} style={{ position: "absolute", top: "1rem", right: "1rem", zIndex: 1 }} />

            {filteredMatchedList?.map((data) => (
                <div className="surface-card p-3">
                    <div className="flex flex-row p-ai-center justify-content-between">
                        <div className="flex flex-row p-ai-center">
                            <Avatar image={data?.userId?.profileImage ? `${baseURL}${data?.userId?.profileImage}` : defaultImg} size="large" shape="circle" style={{ backgroundColor: "inherit" }} />
                            {/* <Avatar image="path/to/profile.jpg" shape="circle" size="large" /> */}
                            <div className="ml-3">
                                <div className="p-text-bold mb-1 mt-3" style={{ fontWeight: "bold" }}>
                                    {`${data?.userId?.firstName || ""} ${data?.userId?.lastName || ""}`}
                                </div>
                                <Rating value={data?.userId?.totalRating} readOnly stars={data?.userId?.totalRatingCount} cancel={false} />
                            </div>
                        </div>
                        <div className="flex flex-row p-2 items-center">
                            {statusChanes ? (
                                <h5>In Progress</h5>
                            ) : (
                                <>
                                    <Button
                                        style={{ background: "red", justifyContent: "center" }}
                                        className="w-8 h-8 rounded-full bg-red-600 text-white flex  items-center mx-1 shadow-md"
                                        onClick={() => {
                                            handleRejectRequest(data._id);
                                        }}
                                    >
                                        <i className="pi pi-times text-lg"></i>
                                    </Button>
                                </>
                            )}
                        </div>
                    </div>

                    <hr className="my-3" />
                    <div className="flex flex-row justify-content-between items-center">
                        <div className="flex align-items-center text-white text-md">Date and Time</div>
                        <div className="flex align-items-center justify-content-between flex-wrap ml-2">
                            <div className="flex align-items-center">
                                <span className="font-semibold">{moment(data?.date).format("Do MMM, YYYY hh:mm A")}</span>
                            </div>
                            {/* <div className='flex align-items-center'>
                                <span className='font-semibold'>{data.date}</span>
                                <span className='mx-2 font-semibold'>{data.time}</span>
                            </div> */}
                        </div>
                    </div>

                    <div className="flex flex-row justify-content-between mt-1">
                        <Timeline
                            value={[
                                { status: data?.startPoint?.placeName ? data?.startPoint?.placeName : "Not found", icon: "pi pi-map-marker" },
                                { status: data?.endPoint?.placeName ? data?.endPoint?.placeName : "Not found", icon: "pi pi-flag" },
                            ]}
                            // value={events}
                            align="left"
                            className="custom-timeline"
                            marker={(item) => (
                                <span className={`p-timeline-event-icon p-pt-2 text-white`}>
                                    <i className={item?.icon} style={{ fontSize: "1.5rem" }}></i>
                                </span>
                            )}
                            content={(item) => (
                                <div className="flex flex-column">
                                    <span>{item.status}</span>
                                </div>
                            )}
                        />
                    </div>

                    <hr className="my-1" />
                    <div className="flex flex-column table-container">
                        <div className="table-row flex justify-content-between">
                            <div className="text-sm text-center flex-1">Distance</div>
                            {/* <div className="text-sm text-center flex-1">Match</div> */}
                            {/* <div className="text-sm text-center flex-1">Requests</div> */}
                            <div className="text-sm text-center flex-1">Duration</div>
                            <div className="text-sm text-center flex-1">Fare</div>
                            <div className="text-sm text-center flex-1">Booked</div>
                        </div>
                    </div>

                    <div className="flex flex-column m-3 mt-0">
                        <div className="table-row flex justify-content-between">
                            <div className="text-sm text-center flex-1">{data?.distance ? `${(data.distance / 1000).toFixed(2)} km` : "0 km"}</div>
                            {/* <div className="text-sm text-center flex-1">{data?.matchedCount || data?.matchCount || 0}</div> */}
                            {/* <div className="text-sm text-center flex-1">{data?.requestCount || data?.requestedCount || 0}</div> */}
                            <div className="text-sm text-center flex-1">{data?.duration ? `${Math.floor(data.duration / 3600)}h ${Math.floor((data.duration % 3600) / 60)}m` : "0h 0m"}</div>
                            <div className="text-sm text-center flex-1">{data?.fare}</div>
                            <div className="text-sm text-center flex-1">{data?.bookedSeats || 0}</div>
                        </div>
                    </div>
                    {/* <div className="flex text-center justify-content-center p-2">
                        <i className="pi pi-user mr-2"></i>
                        <Tag>{data?.status}</Tag>
                    </div> */}
                    {/* <div>
                        <Button
                            type="button"
                            className="block font-medium mx-auto mt-3 mb-3 text-lg w-9rem"
                            // label={data.events[0].status}
                            onClick={() => history.push("/ride-status")}
                        />
                    </div> */}
                </div>
            ))}
            <Dialog className="surface-card mt-8" header="Ride Started" visible={visible} style={{ width: "700px", maxWidth: "90%" }} onHide={toggleDialog} modal>
                <div style={{ margin: "0 auto", maxWidth: "80vw", height: "70vh" }}>
                    <GoogleMapComp directions={directions} mapLoading={handleMapLoaded} />
                </div>
            </Dialog>
        </div>
    );
};

export default ConfirmRides;
